import { render, staticRenderFns } from "./platformParaTable.vue?vue&type=template&id=00c886dc&scoped=true&"
import script from "./platformParaTable.vue?vue&type=script&lang=js&"
export * from "./platformParaTable.vue?vue&type=script&lang=js&"
import style0 from "./platformParaTable.vue?vue&type=style&index=0&id=00c886dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c886dc",
  null
  
)

export default component.exports